import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { IMyOptions, IMyDateModel } from 'mydatepicker'

const DatePickerOptions: IMyOptions = {
  dateFormat: 'yyyy-mm-dd',
  dayLabels: {su: '日', mo: '一', tu: '二', we: '三', th: '四', fr: '五', sa: '六'},
  monthLabels: { 1: '一月', 2: '二月', 3: '三月', 4: '四月', 5: '五月', 6: '六月', 7: '七月', 8: '八月', 9: '九月', 10: '十月', 11: '十一月', 12: '十二月' },
  todayBtnTxt: '今天'
}

@Component({
  selector: 'app-date-picker-com',
  templateUrl: './date-picker.com.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatePickerComponent), multi: true }
  ]
})

export class DatePickerComponent implements ControlValueAccessor {

  @Input() selDate = null
  options: IMyOptions = {
    dateFormat: 'yyyy-mm-dd',
    dayLabels: {su: '日', mo: '一', tu: '二', we: '三', th: '四', fr: '五', sa: '六'},
    monthLabels: { 1: '一月', 2: '二月', 3: '三月', 4: '四月', 5: '五月', 6: '六月', 7: '七月', 8: '八月', 9: '九月', 10: '十月', 11: '十一月', 12: '十二月' },
    todayBtnTxt: '今天'
  }
  propagateChange = (_: any) => {}

  writeValue(value: string) {
    if (value !== undefined && value !== null) {
      this.selDate = value
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn
  }

  registerOnTouched(): void {}

  onDateChanged(e: IMyDateModel): void {
    this.selDate = e.formatted
    this.propagateChange(this.selDate)
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/form-snippets/date-picker/date-picker.com.ts